<template>
    <el-tooltip
        v-if="data !== ''"
        :content="textTooltip"
        :placement="placementTooltip"
        :open-delay="openDelayTooltip"
        :visible-arrow="false"
    >
        <i
            v-clipboard:copy="data"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            :class="['copy-btn', icon]"
            @click="$emit('clicked')"
        >
        </i>
    </el-tooltip>
</template>

<script>
export default {
    props: {
        data: {
            type: String,
            required: true,
        },
        placementTooltip: {
            type: String,
            required: false,
            default: 'bottom',
        },
        openDelayTooltip: {
            type: Number,
            required: false,
            default: 0,
        },
        textTooltip: {
            type: String,
            required: false,
            default: 'Copier',
        },
        icon: {
            type: String,
            required: false,
            default: 'icon-duplicate',
        },
        useNotif: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        onCopy: function (e) {
            if (this.useNotif) {
                Push.success(this.$l10n.__('Copié dans votre presse-papier'));
            }
        },
        onError: function (e) {
            if (this.useNotif) {
                Push.error(this.$l10n.__('Erreur lors de la copie dans votre presse-papier'));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.copy-btn {
    color: var(--colors-common-text-standard-default);
    display: inline-block;
    transform: translateX(-50%);
    position: relative;
    opacity: 0;
    transition: all 100ms ease-in-out;

    &::after {
        content: '';
        position: absolute;
        display: block;
        width: 22px;
        height: 22px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: var(--colors-common-background-primary-hover-alt);
        border-radius: 50%;
        z-index: 1;
        opacity: 0;
    }

    &::before {
        position: relative;
        z-index: 2;
    }
}

.copy-element:hover,
.copy-element-fixed {
    .copy-btn {
        transform: translateX(5px);
        opacity: 1;
        cursor: pointer;

        &:hover {
            color: var(--colors-common-text-standard-active);

            &::after {
                opacity: 1;
            }
        }
    }
}
</style>
